var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimestampApiDefaultSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12.30582mm",
    height: "12mm",
    viewBox: "0 0 34.88264 34.01575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #4b9fd8;\n      }\n\n      .b {\n        fill: #181f28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.88264,14.741a2.46518,2.46518,0,1,0-3.75331,2.09321,13.9984,13.9984,0,0,1-4.13657,10.16889A14.12814,14.12814,0,1,1,21.70551,3.69538a2.47387,2.47387,0,1,0,1.10578-2.66321,17.0011,17.0011,0,1,0,6.21994,28.00941A16.85472,16.85472,0,0,0,34.012,16.60679,2.44841,2.44841,0,0,0,34.88264,14.741Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.97619,2.75842a2.41778,2.41778,0,0,0-2.42608,2.853L16.99437,18.16661l-5.98629-5.98683a2.52432,2.52432,0,1,0-2.03823,2.03878l7.00528,7.00576a1.44106,1.44106,0,0,0,2.03847,0L31.58874,7.64969a2.46129,2.46129,0,1,0,.38745-4.89127Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimestampApiDefaultSmall);
export default __webpack_public_path__ + "static/media/timestamp-api_default_small.d22aaf393c69413829d27401f4b10e2e.svg";
export { ForwardRef as ReactComponent };